import { Component, input, output } from '@angular/core';
import { Channel, PaymentproviderShort } from '@frontend/masterdata';

@Component({
    selector: 'frontend-frontendlib-components-paymentprovider-switcher',
    templateUrl: './paymentprovider-switcher.component.html',
    styleUrls: ['./paymentprovider-switcher.component.css'],
    standalone: true
})
export class PaymentproviderSwitcherComponent {

    channel = input.required<Channel | undefined>();
    public paymentprovider = input.required<PaymentproviderShort>();
    isOpen = input.required<boolean>();
    public togglePaymentProvider = output<void>();

    public doTogglePaymentProvider() {
        this.togglePaymentProvider.emit();
    }
}